module.exports = require('./dist/index.js');

Object.defineProperty(module.exports, '__esModule', {
  value: true
});
